/* ========================================
   Sálarhestur Theme JavaScript
   ======================================== */

(function() {
  'use strict';

  /* --- Sticky Header Shadow --- */
  const header = document.querySelector('[data-header]');
  if (header) {
    /* Enable mega-menu transitions only after page is fully painted */
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        header.classList.add('is-ready');
      });
    });
    window.addEventListener('scroll', function() {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* --- Mobile Menu --- */
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const mobileOverlay = document.querySelector('[data-menu-overlay]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');

  function openMobileMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (mobileOverlay) mobileOverlay.classList.add('is-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (mobileOverlay) mobileOverlay.classList.remove('is-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    /* Reset to main panel after transition */
    setTimeout(function() {
      var pm = document.querySelector('[data-mobile-panel-main]');
      var pc = document.querySelector('[data-mobile-panel-collections]');
      if (pm) pm.classList.remove('is-hidden');
      if (pc) pc.classList.remove('is-visible');
    }, 300);
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (menuClose) menuClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  /* Mobile panel slide: Collections */
  var panelMain = document.querySelector('[data-mobile-panel-main]');
  var panelCollections = document.querySelector('[data-mobile-panel-collections]');
  var collectionsOpen = document.querySelector('[data-mobile-collections-open]');
  var collectionsBack = document.querySelector('[data-mobile-collections-back]');

  function showCollectionsPanel() {
    if (panelMain) panelMain.classList.add('is-hidden');
    if (panelCollections) panelCollections.classList.add('is-visible');
  }

  function hideCollectionsPanel() {
    if (panelMain) panelMain.classList.remove('is-hidden');
    if (panelCollections) panelCollections.classList.remove('is-visible');
  }

  if (collectionsOpen) collectionsOpen.addEventListener('click', showCollectionsPanel);
  if (collectionsBack) collectionsBack.addEventListener('click', hideCollectionsPanel);

  /* --- Mega Menu --- */
  document.querySelectorAll('.header__mega-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function(e) {
      e.stopPropagation();
      var expanded = this.getAttribute('aria-expanded') === 'true';
      /* Close all other mega menus first */
      document.querySelectorAll('.header__mega-toggle').forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
      });
      this.setAttribute('aria-expanded', String(!expanded));
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.header__menu-item--mega')) {
      document.querySelectorAll('.header__mega-toggle').forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* --- Cart Drawer --- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* Cart toggle button */
  document.querySelectorAll('[data-cart-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  /* Cart close buttons */
  document.querySelectorAll('[data-cart-close]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      closeCartDrawer();
    });
  });

  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  /* Close on Escape */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeMobileMenu();
    }
  });

  /* --- Cart AJAX Operations --- */
  var freeShippingThreshold = 8000; /* 80€ in cents */

  function formatMoneyCurrency(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  function updateCartDrawer() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var body = document.querySelector('[data-cart-body]');
        var footer = document.querySelector('[data-cart-footer]');
        var shippingBar = document.querySelector('.cart-drawer__shipping-bar');

        if (!body) return;

        /* Update cart count */
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-cart-count', cart.item_count);
        });

        /* Update shipping bar */
        if (shippingBar) {
          var remaining = freeShippingThreshold - cart.total_price;
          var pct = Math.min(cart.total_price / freeShippingThreshold * 100, 100);
          if (remaining > 0) {
            shippingBar.innerHTML =
              '<p class="cart-drawer__shipping-text">Noch <strong>' + formatMoneyCurrency(remaining) + '</strong> bis zum kostenlosen Versand</p>' +
              '<div class="cart-drawer__shipping-progress"><div class="cart-drawer__shipping-fill" style="width:' + pct + '%;"></div></div>';
          } else {
            shippingBar.innerHTML =
              '<p class="cart-drawer__shipping-text cart-drawer__shipping-text--free">&#10003; Kostenloser Versand!</p>' +
              '<div class="cart-drawer__shipping-progress"><div class="cart-drawer__shipping-fill" style="width:100%;"></div></div>';
          }
        }

        if (cart.item_count === 0) {
          body.innerHTML =
            '<div class="cart-drawer__empty">' +
              '<div class="cart-drawer__empty-icon"><svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></div>' +
              '<p class="cart-drawer__empty-title">Da ist noch Platz!</p>' +
              '<p class="cart-drawer__empty-text">Dein Warenkorb wartet auf ein paar Seelenpferd-Sch\u00e4tze.</p>' +
              '<a href="/collections/all" class="btn btn--primary" data-cart-close>Jetzt shoppen</a>' +
            '</div>';
          if (footer) footer.style.display = 'none';
          var extras = document.querySelector('[data-cart-extras]');
          if (extras) extras.style.display = 'none';
          bindCartEvents();
          return;
        }

        /* Build items */
        var itemsHTML = '';
        cart.items.forEach(function(item) {
          var imgHTML = '';
          if (item.image) {
            var imgSrc = item.image.replace(/(\.[^.]+)$/, '_200x$1');
            imgHTML = '<img src="' + imgSrc + '" alt="' + escapeHtml(item.title) + '" width="90" height="90" loading="lazy">';
          }
          var variantHTML = '';
          if (item.variant_title && item.variant_title !== 'Default Title') {
            variantHTML = '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>';
          }
          itemsHTML +=
            '<div class="cart-drawer__item" data-cart-item="' + item.key + '">' +
              '<a href="' + item.url + '" class="cart-drawer__item-image">' + imgHTML + '</a>' +
              '<div class="cart-drawer__item-info">' +
                '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
                variantHTML +
                '<div class="cart-drawer__item-bottom">' +
                  '<div class="cart-drawer__item-qty">' +
                    '<button type="button" class="cart-drawer__qty-btn" data-change-qty="' + item.key + '" data-direction="down">\u2212</button>' +
                    '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
                    '<button type="button" class="cart-drawer__qty-btn" data-change-qty="' + item.key + '" data-direction="up">+</button>' +
                  '</div>' +
                  '<button class="cart-drawer__item-delete" data-remove-item="' + item.key + '" aria-label="Entfernen">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>' +
                  '</button>' +
                  '<span class="cart-drawer__item-price">' + formatMoneyCurrency(item.final_line_price) + '</span>' +
                '</div>' +
              '</div>' +
            '</div>';
        });

        body.innerHTML = '<div class="cart-drawer__items" data-cart-items>' + itemsHTML + '</div>';

        /* Show extras + footer */
        var extras = document.querySelector('[data-cart-extras]');
        if (extras) extras.style.display = '';
        if (footer) {
          footer.style.display = '';
          var totalEl = footer.querySelector('[data-cart-total]');
          if (totalEl) totalEl.textContent = formatMoneyCurrency(cart.total_price);
        }

        /* Restore note from cart data */
        var noteInput = document.querySelector('.cart-drawer__notes-input');
        if (noteInput && cart.note) noteInput.value = cart.note;

        /* Restore discount applied state */
        if (window._discountCode) {
          var discountForm = document.querySelector('.cart-drawer__discount-form');
          if (discountForm) {
            discountForm.innerHTML = '<p class="cart-drawer__discount-applied">&#10003; <strong>' + escapeHtml(window._discountCode) + '</strong> wird an der Kasse angewendet</p>';
          }
        }

        bindCartEvents();
      });
  }

  function bindCartEvents() {
    /* Change quantity */
    document.querySelectorAll('[data-change-qty]').forEach(function(btn) {
      btn.onclick = function() {
        var key = this.getAttribute('data-change-qty');
        var direction = this.getAttribute('data-direction');
        var qtyEl = this.parentElement.querySelector('.cart-drawer__qty-value');
        var currentQty = parseInt(qtyEl.textContent);
        var newQty = direction === 'up' ? currentQty + 1 : Math.max(0, currentQty - 1);

        /* Show loading on the item */
        var item = this.closest('.cart-drawer__item');
        if (item) item.classList.add('is-loading');

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        }).then(function() {
          updateCartDrawer();
        });
      };
    });

    /* Remove item (trash icon) */
    document.querySelectorAll('[data-remove-item]').forEach(function(btn) {
      btn.onclick = function() {
        var key = this.getAttribute('data-remove-item');
        var item = this.closest('.cart-drawer__item');
        if (item) item.classList.add('is-loading');

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function() {
          updateCartDrawer();
        });
      };
    });

    /* Cart close buttons inside drawer */
    document.querySelectorAll('[data-cart-body] [data-cart-close]').forEach(function(btn) {
      btn.onclick = function(e) {
        e.preventDefault();
        closeCartDrawer();
      };
    });

    /* Save order note on blur */
    var noteInput = document.querySelector('.cart-drawer__notes-input');
    if (noteInput) {
      noteInput.onblur = function() {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteInput.value })
        });
      };
    }

    /* Discount code → apply to checkout URL */
    var discountBtn = document.querySelector('.cart-drawer__discount-apply');
    if (discountBtn) {
      discountBtn.onclick = function() {
        var input = document.querySelector('.cart-drawer__discount-input');
        if (!input) return;
        var code = input.value.trim();
        if (!code) return;

        window._discountCode = code;

        /* Visual feedback */
        var form = input.closest('.cart-drawer__discount-form');
        if (form) {
          form.innerHTML = '<p class="cart-drawer__discount-applied">&#10003; <strong>' + escapeHtml(code) + '</strong> wird an der Kasse angewendet</p>';
        }

        /* Update checkout link */
        var checkoutLink = document.querySelector('[data-checkout-link]');
        if (checkoutLink) {
          checkoutLink.href = '/checkout?discount=' + encodeURIComponent(code);
        }
      };
    }

    /* Restore discount code if previously entered */
    if (window._discountCode) {
      var checkoutLink = document.querySelector('[data-checkout-link]');
      if (checkoutLink) {
        checkoutLink.href = '/checkout?discount=' + encodeURIComponent(window._discountCode);
      }
    }

    /* Accordion animation for discount/notes */
    document.querySelectorAll('[data-cart-accordion]').forEach(function(details) {
      var summary = details.querySelector('summary');
      var wrap = details.querySelector('.cart-drawer__accordion-wrap');
      if (!summary || !wrap) return;

      summary.onclick = function(e) {
        e.preventDefault();
        if (details.open) {
          wrap.style.gridTemplateRows = '0fr';
          wrap.addEventListener('transitionend', function handler() {
            details.open = false;
            wrap.removeEventListener('transitionend', handler);
          });
        } else {
          details.open = true;
          wrap.style.gridTemplateRows = '0fr';
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              wrap.style.gridTemplateRows = '1fr';
            });
          });
        }
      };
    });
  }

  /* Initial bind */
  bindCartEvents();

  /* --- Add to Cart (AJAX) --- */
  function addToCartWithLoading(button, fetchPromise) {
    if (button) {
      button.classList.add('is-loading');
      button.disabled = true;
    }
    fetchPromise
      .then(function(res) { return res.json(); })
      .then(function() {
        updateCartDrawer();
        openCartDrawer();
      })
      .finally(function() {
        if (button) {
          button.classList.remove('is-loading');
          button.disabled = false;
        }
      });
  }

  document.querySelectorAll('.product-card__form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var button = this.querySelector('button[type="submit"]');
      addToCartWithLoading(button, fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(this)
      }));
    });
  });

  /* Product page add to cart */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var button = this.querySelector('[data-add-to-cart]');
      addToCartWithLoading(button, fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(this)
      }));
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-cart-count', cart.item_count);
        });
      });
  }

  /* --- Product Page: Image Gallery --- */
  var thumbnails = document.querySelectorAll('[data-thumbnail]');
  var slides = document.querySelectorAll('[data-image-slide]');

  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var index = this.getAttribute('data-thumbnail');

      thumbnails.forEach(function(t) { t.classList.remove('is-active'); });
      slides.forEach(function(s) { s.classList.remove('is-active'); });

      this.classList.add('is-active');
      var targetSlide = document.querySelector('[data-image-slide="' + index + '"]');
      if (targetSlide) targetSlide.classList.add('is-active');
    });
  });

  /* --- Product Page: Quantity Selector --- */
  var qtyMinus = document.querySelector('[data-qty-minus]');
  var qtyPlus = document.querySelector('[data-qty-plus]');
  var qtyInput = document.querySelector('[data-qty-input]');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value);
      if (val > 1) qtyInput.value = val - 1;
    });
  }

  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function() {
      qtyInput.value = parseInt(qtyInput.value) + 1;
    });
  }

  /* --- Product Page: Variant Selector --- */
  var optionSelectors = document.querySelectorAll('[data-option-selector]');
  optionSelectors.forEach(function(input) {
    input.addEventListener('change', function() {
      /* Update swatch visual state */
      var parent = this.closest('.product-page__option-values');
      if (parent) {
        parent.querySelectorAll('.product-page__swatch').forEach(function(s) {
          s.classList.remove('is-selected');
        });
        this.closest('.product-page__swatch').classList.add('is-selected');
      }

      /* Build selected options and find matching variant */
      var selectedOptions = [];
      document.querySelectorAll('[data-option-selector]:checked').forEach(function(opt) {
        selectedOptions.push(opt.value);
      });

      /* Update URL with variant */
      var url = new URL(window.location.href);
      var optionString = selectedOptions.join(' / ');

      /* Find the matching variant from the product JSON */
      if (window.productVariants) {
        var variant = window.productVariants.find(function(v) {
          return v.title === optionString || (
            selectedOptions.length === 1 && v.option1 === selectedOptions[0]
          ) || (
            selectedOptions.length === 2 && v.option1 === selectedOptions[0] && v.option2 === selectedOptions[1]
          ) || (
            selectedOptions.length === 3 && v.option1 === selectedOptions[0] && v.option2 === selectedOptions[1] && v.option3 === selectedOptions[2]
          );
        });

        if (variant) {
          /* Update hidden variant ID input */
          var variantInput = document.querySelector('[data-variant-id]');
          if (variantInput) variantInput.value = variant.id;

          /* Update URL */
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());

          /* Update add to cart button */
          var addBtn = document.querySelector('[data-add-to-cart]');
          if (addBtn) {
            addBtn.disabled = !variant.available;
            addBtn.textContent = variant.available ? addBtn.dataset.addText || 'In den Warenkorb' : 'Ausverkauft';
          }
        }
      }
    });
  });

  /* --- Quick View Modal --- */
  var qvModal = document.querySelector('[data-quick-view-modal]');
  var qvOverlay = document.querySelector('[data-quick-view-overlay]');
  var qvBody = document.querySelector('[data-quick-view-body]');
  var qvCloseBtn = document.querySelector('[data-quick-view-close]');

  function openQuickView() {
    if (!qvModal) return;
    qvModal.classList.add('is-open');
    qvModal.setAttribute('aria-hidden', 'false');
    if (qvOverlay) qvOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeQuickView() {
    if (!qvModal) return;
    qvModal.classList.remove('is-open');
    qvModal.setAttribute('aria-hidden', 'true');
    if (qvOverlay) qvOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (qvCloseBtn) qvCloseBtn.addEventListener('click', closeQuickView);
  if (qvOverlay) qvOverlay.addEventListener('click', closeQuickView);

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var url = btn.getAttribute('data-quick-view');
    if (!url) return;

    /* Show modal with loading spinner */
    if (qvBody) qvBody.innerHTML = '<div class="quick-view__loading"><div class="quick-view__spinner"></div></div>';
    openQuickView();

    /* Fetch product page and extract product JSON */
    fetch(url + '.js')
      .then(function(res) { return res.json(); })
      .then(function(product) {
        /* Build two-column layout */
        var left = '';
        var right = '';

        /* LEFT: Alternating image grid (1, 2, 1, 2…) */
        product.images.forEach(function(img, imgIdx) {
          var fullSrc = img.replace(/(\.[^.]+)$/, '_1200x$1');
          var thumbSrc = img.replace(/(\.[^.]+)$/, '_600x$1');
          /* Find image ID by matching src against variant featured images */
          var imgId = '';
          product.variants.forEach(function(v) {
            if (v.featured_image && v.featured_image.src && img.indexOf(v.featured_image.src.split('?')[0].split('/').pop().replace(/_.+\./, '.')) !== -1) {
              imgId = v.featured_image.id;
            }
          });
          left += '<div class="quick-view__image-wrap" data-qv-lightbox-src="' + fullSrc + '" data-qv-image-src="' + img + '">';
          left += '<img class="quick-view__image" src="' + thumbSrc + '" alt="' + escapeHtml(product.title) + '" loading="lazy">';
          left += '</div>';
        });
        if (product.images.length === 0) {
          left = '<div style="aspect-ratio:1;display:flex;align-items:center;justify-content:center;color:var(--neutral-400);"><svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/></svg></div>';
        }

        /* RIGHT: Product info */
        /* Title */
        right += '<h3 class="quick-view__product-title">' + escapeHtml(product.title) + '</h3>';

        /* Price */
        var firstVariant = product.variants[0];
        var priceHTML = '<div class="quick-view__price">';
        if (firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price) {
          priceHTML += '<span class="quick-view__price--sale">' + formatMoney(firstVariant.price) + '</span>';
          priceHTML += '<span class="quick-view__price--compare">' + formatMoney(firstVariant.compare_at_price) + '</span>';
        } else {
          priceHTML += '<span>' + formatMoney(firstVariant.price) + '</span>';
        }
        priceHTML += '</div>';
        right += priceHTML;

        /* Options (Color as image swatches, others as text) */
        var colorNames = ['color', 'colour', 'farbe', 'couleur'];
        product.options.forEach(function(option, optIndex) {
          var isColor = colorNames.indexOf(option.name.toLowerCase()) !== -1;

          /* Build a map: color value → first variant image for that color */
          var colorImageMap = {};
          if (isColor) {
            option.values.forEach(function(val) {
              var variant = product.variants.find(function(v) {
                return v['option' + (optIndex + 1)] === val && v.featured_image;
              });
              if (variant && variant.featured_image) {
                colorImageMap[val] = variant.featured_image.src.replace(/(\.[^.]+)$/, '_200x$1');
              }
            });
          }

          right += '<div class="quick-view__option">';
          right += '<label class="quick-view__option-label">' + escapeHtml(option.name) + '<span class="quick-view__option-label-value" data-qv-option-display="' + optIndex + '">' + escapeHtml(option.values[0]) + '</span></label>';
          right += '<div class="quick-view__option-values">';
          option.values.forEach(function(val, i) {
            var selected = i === 0 ? ' is-selected' : '';
            var checked = i === 0 ? ' checked' : '';
            if (isColor && colorImageMap[val]) {
              right += '<label class="quick-view__swatch quick-view__swatch--image' + selected + '">';
              right += '<input type="radio" name="qv-option-' + optIndex + '" value="' + escapeHtml(val) + '"' + checked + ' data-qv-option="' + optIndex + '">';
              right += '<span class="quick-view__swatch-label"><img class="quick-view__swatch-img" src="' + colorImageMap[val] + '" alt="' + escapeHtml(val) + '"></span>';
              right += '</label>';
            } else {
              right += '<label class="quick-view__swatch' + selected + '">';
              right += '<input type="radio" name="qv-option-' + optIndex + '" value="' + escapeHtml(val) + '"' + checked + ' data-qv-option="' + optIndex + '">';
              right += '<span class="quick-view__swatch-label">' + escapeHtml(val) + '</span>';
              right += '</label>';
            }
          });
          right += '</div></div>';
        });

        /* Quantity */
        right += '<div class="quick-view__quantity">';
        right += '<label class="quick-view__option-label">Anzahl</label>';
        right += '<div class="quick-view__qty-selector">';
        right += '<button type="button" class="quick-view__qty-btn" data-qv-qty-minus>−</button>';
        right += '<input type="number" class="quick-view__qty-input" value="1" min="1" data-qv-qty-input>';
        right += '<button type="button" class="quick-view__qty-btn" data-qv-qty-plus>+</button>';
        right += '</div></div>';

        /* Buttons */
        right += '<div class="quick-view__buttons">';
        right += '<button class="btn btn--primary btn--full" data-qv-add-to-cart' + (firstVariant.available ? '' : ' disabled') + '>' + (firstVariant.available ? 'In den Warenkorb' : 'Ausverkauft') + '</button>';
        right += '<div data-shopify="payment-button" data-has-selling-plan="false" data-variant-id="' + firstVariant.id + '"></div>';
        right += '<a href="' + url + '" class="quick-view__view-full">Alle Details anzeigen</a>';
        right += '</div>';

        /* Assemble grid */
        var html = '<div class="quick-view__grid">';
        html += '<div class="quick-view__images">' + left + '</div>';
        html += '<div class="quick-view__info">' + right + '</div>';
        html += '</div>';

        if (qvBody) qvBody.innerHTML = html;

        /* --- Bind interactivity --- */
        var qvVariants = product.variants;
        var selectedOptions = product.options.map(function(o) { return o.values[0]; });
        var currentVariantId = firstVariant.id;

        /* Swatch selection */
        qvBody.querySelectorAll('[data-qv-option]').forEach(function(input) {
          input.addEventListener('change', function() {
            var optIdx = parseInt(this.getAttribute('data-qv-option'));
            selectedOptions[optIdx] = this.value;

            /* Update swatch visuals */
            var parent = this.closest('.quick-view__option-values');
            parent.querySelectorAll('.quick-view__swatch').forEach(function(s) { s.classList.remove('is-selected'); });
            this.closest('.quick-view__swatch').classList.add('is-selected');

            /* Update label display value (e.g. "Farbe Arctic White") */
            var displayEl = qvBody.querySelector('[data-qv-option-display="' + optIdx + '"]');
            if (displayEl) displayEl.textContent = this.value;

            /* Find matching variant */
            var match = qvVariants.find(function(v) {
              return selectedOptions.every(function(opt, i) {
                return v['option' + (i + 1)] === opt;
              });
            });

            if (match) {
              currentVariantId = match.id;
              /* Update price */
              var priceEl = qvBody.querySelector('.quick-view__price');
              if (priceEl) {
                var pHTML = '';
                if (match.compare_at_price && match.compare_at_price > match.price) {
                  pHTML = '<span class="quick-view__price--sale">' + formatMoney(match.price) + '</span><span class="quick-view__price--compare">' + formatMoney(match.compare_at_price) + '</span>';
                } else {
                  pHTML = '<span>' + formatMoney(match.price) + '</span>';
                }
                priceEl.innerHTML = pHTML;
              }
              /* Update add button */
              var addBtn = qvBody.querySelector('[data-qv-add-to-cart]');
              if (addBtn) {
                addBtn.disabled = !match.available;
                addBtn.textContent = match.available ? 'In den Warenkorb' : 'Ausverkauft';
              }
              /* Re-init dynamic checkout button with new variant */
              var payBtn = qvBody.querySelector('[data-shopify="payment-button"]');
              if (payBtn) {
                payBtn.setAttribute('data-variant-id', match.id);
                if (window.Shopify && Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }
              }
              /* Scroll to variant image */
              if (match.featured_image && match.featured_image.src) {
                var targetFile = match.featured_image.src.split('?')[0].split('/').pop();
                var qvWraps = qvBody.querySelectorAll('.quick-view__image-wrap');
                qvWraps.forEach(function(wrap) {
                  var wrapSrc = wrap.getAttribute('data-qv-image-src') || '';
                  if (wrapSrc.indexOf(targetFile) !== -1) {
                    wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }
                });
              }
            }
          });
        });

        /* Quantity +/- */
        var qvQtyInput = qvBody.querySelector('[data-qv-qty-input]');
        var qvQtyMinus = qvBody.querySelector('[data-qv-qty-minus]');
        var qvQtyPlus = qvBody.querySelector('[data-qv-qty-plus]');
        if (qvQtyMinus && qvQtyInput) {
          qvQtyMinus.addEventListener('click', function() {
            var v = parseInt(qvQtyInput.value);
            if (v > 1) qvQtyInput.value = v - 1;
          });
        }
        if (qvQtyPlus && qvQtyInput) {
          qvQtyPlus.addEventListener('click', function() {
            qvQtyInput.value = parseInt(qvQtyInput.value) + 1;
          });
        }

        /* Add to Cart */
        var addToCartBtn = qvBody.querySelector('[data-qv-add-to-cart]');
        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', function() {
            var qty = parseInt(qvQtyInput ? qvQtyInput.value : 1);
            var self = this;
            self.classList.add('is-loading');
            self.disabled = true;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: currentVariantId, quantity: qty })
            })
            .then(function(r) { return r.json(); })
            .then(function() {
              closeQuickView();
              updateCartDrawer();
              openCartDrawer();
            })
            .finally(function() {
              self.classList.remove('is-loading');
              self.disabled = false;
            });
          });
        }

        /* Initialize Shopify Dynamic Checkout Button (Shop Pay) */
        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        /* Lightbox for images — collect all sources */
        var lightboxSrcs = [];
        qvBody.querySelectorAll('[data-qv-lightbox-src]').forEach(function(wrap, idx) {
          lightboxSrcs.push({
            src: wrap.getAttribute('data-qv-lightbox-src'),
            alt: wrap.querySelector('img') ? wrap.querySelector('img').alt : ''
          });
          wrap.addEventListener('click', function() {
            openLightbox(lightboxSrcs, idx);
          });
        });
      })
      .catch(function() {
        if (qvBody) qvBody.innerHTML = '<p style="text-align:center;color:var(--color-text-secondary);padding:var(--space-2xl);">Fehler beim Laden. <a href="' + url + '">Zur Produktseite</a></p>';
      });
  });

  /* Close quick view on Escape */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeQuickView();
  });

  /* --- Image Lightbox Slider --- */
  var lightbox = null;
  var lbImages = [];
  var lbIndex = 0;

  function buildLightbox() {
    lightbox = document.createElement('div');
    lightbox.className = 'quick-view__lightbox';
    lightbox.innerHTML =
      '<div class="quick-view__lightbox-track">' +
        '<div class="quick-view__lightbox-slides"></div>' +
        '<button class="quick-view__lightbox-arrow quick-view__lightbox-arrow--prev" data-lb-prev>' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
        '</button>' +
        '<button class="quick-view__lightbox-arrow quick-view__lightbox-arrow--next" data-lb-next>' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
        '</button>' +
        '<div class="quick-view__lightbox-counter" data-lb-counter></div>' +
      '</div>';
    document.body.appendChild(lightbox);

    /* Close on click anywhere except image and arrows */
    lightbox.addEventListener('click', function(e) {
      if (e.target.closest('.quick-view__lightbox-arrow') || e.target.tagName === 'IMG') return;
      closeLightbox();
    });

    /* Arrow clicks */
    lightbox.querySelector('[data-lb-prev]').addEventListener('click', function(e) {
      e.stopPropagation();
      goToSlide(lbIndex - 1);
    });
    lightbox.querySelector('[data-lb-next]').addEventListener('click', function(e) {
      e.stopPropagation();
      goToSlide(lbIndex + 1);
    });
  }

  window.openLightbox = function openLightbox(images, startIndex) {
    if (!lightbox) buildLightbox();
    lbImages = images;
    lbIndex = startIndex || 0;

    /* Build slides */
    var slidesContainer = lightbox.querySelector('.quick-view__lightbox-slides');
    var html = '';
    images.forEach(function(img, i) {
      html += '<div class="quick-view__lightbox-slide' + (i === lbIndex ? ' is-active' : '') + '">';
      html += '<img src="' + img.src + '" alt="' + escapeHtml(img.alt) + '">';
      html += '</div>';
    });
    slidesContainer.innerHTML = html;

    updateLightboxUI();
    lightbox.offsetHeight;
    lightbox.classList.add('is-open');
  }

  function goToSlide(idx) {
    if (idx < 0) idx = lbImages.length - 1;
    if (idx >= lbImages.length) idx = 0;
    lbIndex = idx;

    var slides = lightbox.querySelectorAll('.quick-view__lightbox-slide');
    slides.forEach(function(s, i) {
      s.classList.toggle('is-active', i === idx);
    });
    updateLightboxUI();
  }

  function updateLightboxUI() {
    var counter = lightbox.querySelector('[data-lb-counter]');
    if (counter) counter.textContent = (lbIndex + 1) + ' / ' + lbImages.length;
  }

  function closeLightbox() {
    if (lightbox) lightbox.classList.remove('is-open');
  }

  document.addEventListener('keydown', function(e) {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') goToSlide(lbIndex - 1);
    if (e.key === 'ArrowRight') goToSlide(lbIndex + 1);
  });

  /* Format money helper (cents to formatted EUR) */
  window.formatMoney = function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' \u20AC';
  }

  /* --- Product Slider --- */
  document.querySelectorAll('[data-product-slider]').forEach(function(slider) {
    var section = slider.closest('.featured-collection');
    if (!section) return;
    var prevBtn = section.querySelector('[data-slider-prev]');
    var nextBtn = section.querySelector('[data-slider-next]');
    var progressFill = section.querySelector('[data-slider-progress]');
    var slide = slider.querySelector('.featured-collection__slide');
    if (!slide) return;

    function getScrollAmount() {
      return slide.offsetWidth + parseInt(getComputedStyle(slider).gap);
    }

    function updateControls() {
      var scrollLeft = slider.scrollLeft;
      var maxScroll = slider.scrollWidth - slider.offsetWidth;
      if (prevBtn) prevBtn.disabled = scrollLeft < 2;
      if (nextBtn) nextBtn.disabled = scrollLeft >= maxScroll - 2;

      /* Update progress bar */
      if (progressFill && maxScroll > 0) {
        var viewRatio = slider.offsetWidth / slider.scrollWidth;
        var posRatio = scrollLeft / maxScroll;
        var fillWidth = Math.max(viewRatio * 100, 10);
        var translateX = posRatio * (100 - fillWidth) / (fillWidth / 100);
        progressFill.style.width = fillWidth + '%';
        progressFill.style.transform = 'translateX(' + (posRatio * ((1 / viewRatio) - 1) * 100) + '%)';
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function() {
      slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    slider.addEventListener('scroll', updateControls, { passive: true });
    updateControls();
  });

  /* --- FAQ Accordion Animation --- */
  document.querySelectorAll('.faq__item').forEach(function(details) {
    var summary = details.querySelector('.faq__question');
    var wrap = details.querySelector('.faq__answer-wrap');
    if (!summary || !wrap) return;

    summary.addEventListener('click', function(e) {
      e.preventDefault();
      if (details.open) {
        /* Closing: animate first, then remove open */
        wrap.style.gridTemplateRows = '0fr';
        wrap.addEventListener('transitionend', function handler() {
          details.open = false;
          wrap.removeEventListener('transitionend', handler);
        });
      } else {
        /* Opening: set open, force 0fr, then animate to 1fr */
        details.open = true;
        wrap.style.gridTemplateRows = '0fr';
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            wrap.style.gridTemplateRows = '1fr';
          });
        });
      }
    });
  });

})();
